import { render, staticRenderFns } from "./JobCardChip.vue?vue&type=template&id=f4057bec&scoped=true&"
import script from "./JobCardChip.vue?vue&type=script&lang=js&"
export * from "./JobCardChip.vue?vue&type=script&lang=js&"
import style0 from "./JobCardChip.vue?vue&type=style&index=0&id=f4057bec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4057bec",
  null
  
)

export default component.exports